import { computed, ref } from 'vue';
import { defineStore } from 'pinia';

import type { Marker, Rectangle } from '@libs/maps';

import { useHotelDetailsPanelStore } from './hotelDetailsPanelStore';
import {
  getInitialMapView,
  getMapMarker,
  getMapMarkerFormatters,
} from './hotelDetailsMapStoreLogic';

export const useHotelDetailsMapStore = defineStore(
  'HotelDetailsMapStore',
  () => {
    const hotelDetailsPanelStore = useHotelDetailsPanelStore();

    // State
    const shouldShowFullscreenMap = ref<boolean>(false);

    // Actions
    function openDynamicMapModal(): void {
      shouldShowFullscreenMap.value = true;
    }

    function closeDynamicMapModal(): void {
      shouldShowFullscreenMap.value = false;
    }

    // Getters
    const mapMarker = computed<Marker | undefined>(() =>
      getMapMarker(hotelDetailsPanelStore.hotelStaticData)
    );

    const initialMapView = computed<Rectangle | undefined>(() =>
      getInitialMapView(hotelDetailsPanelStore.hotelStaticData)
    );

    return {
      // State
      shouldShowFullscreenMap,

      // Actions
      closeDynamicMapModal,
      openDynamicMapModal,
      getMapMarkerFormatters,

      // Getters
      mapMarker,
      initialMapView,
    };
  }
);
